import { ReservationSummaryDto } from '@/services/platform/api/model';
import { BookingCard } from './card';
import { AppContext } from '@/lib/core/types';
import { useClientTranslation } from '@/lib/core';

export interface BookingListProps {
  reservations: ReservationSummaryDto[];
  emptyMessage?: string;
  context?: AppContext | undefined;
}

export function BookingList({ reservations, emptyMessage, context }: BookingListProps) {
  const translation = useClientTranslation();
  if (reservations.length === 0) {
    if (!emptyMessage) {
      emptyMessage = translation('App.Labels.NoUpcomingReservations');
    }
    return (
      <p className="font-pp-neue-montreal text-jncquoi-neutral-400 py-12 text-center text-[14px] tracking-[0.25px]">
        {emptyMessage}
      </p>
    );
  }

  return (
    <ul className="flex flex-col gap-8">
      {reservations.map(r => (
        <li key={r.publicGuid ?? r.name}>
          <BookingCard booking={r} context={context} />
        </li>
      ))}
    </ul>
  );
}
